import { render, staticRenderFns } from "./TrainStationDepartures.vue?vue&type=template&id=6e1f981b&lang=pug"
import script from "./TrainStationDepartures.vue?vue&type=script&lang=js"
export * from "./TrainStationDepartures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports